module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-chapt",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#introduction"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "greenk"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("W")]), _vm._v(" "), _c('span', {
    staticClass: "violat"
  }, [_vm._v("I")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "greenk"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01a#ch01a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS ONE &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01a#ch01b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("G")]), _vm._v(" "), _c('span', {
    staticClass: "violat"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _vm._v(" "), _c('span', {
    staticClass: "orange"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("O")]), _vm._v(" "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("Y")]), _vm._v(" "), _c('span', {
    staticClass: "violat"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("R")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02a#ch02a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSON THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("N")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("G")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "orange"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("H")]), _vm._v(" "), _c('span', {
    staticClass: "orange"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("G")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03a#ch03a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSON FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "greenp"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "greenp"
  }, [_vm._v("G")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("Y")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "greenp"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "blue1"
  }, [_vm._v("R")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04a#ch04a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSON FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "orange1"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "pink"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("V")]), _c('span', {
    staticClass: "bluel"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "orange1"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "pink"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "bluel"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "orange1"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "pink"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "bluel"
  }, [_vm._v("N")]), _vm._v(" "), _c('span', {
    staticClass: "orange1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("U")]), _c('span', {
    staticClass: "pink"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "bluel"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05a#ch05a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS SIX")])]), _vm._v(", "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05a#ch05b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("SEVEN, &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05a#ch05c",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("EIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "greenm"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "greena"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("U")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "greenm"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "greena"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("F")]), _vm._v(" "), _c('span', {
    staticClass: "orange"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("Y")]), _vm._v(" "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "greena"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "blue"
  }, [_vm._v("G")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06a#ch06a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS NINE &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06a#ch06b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("TEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "red1"
  }, [_vm._v("T")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("L")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("D")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07a#ch07a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS ELEVEN &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07a#ch07b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("TWELVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "blues"
  }, [_vm._v("T")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("É")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("Z")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "blues"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E’")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("U")]), _c('span', {
    staticClass: "blues"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("O")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08a#ch08a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS THIRTEEN &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08a#ch08b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("FOURTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "greenk"
  }, [_vm._v("T")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "violat"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("U")]), _c('span', {
    staticClass: "green"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("É")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "violat"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "green"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09a#ch09a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSON FIFTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _vm._v(" "), _c('span', {
    staticClass: "orange"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("W")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("Y")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "orange"
  }, [_vm._v("K")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10a#ch10a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS SIXTEEN &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10a#ch10b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("SEVENTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "greenk"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "red1"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "greena"
  }, [_vm._v("R")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "greenk"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "greena"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "green"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "greena"
  }, [_vm._v("R")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11a#ch11a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSON EIGHTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "greenp"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("Y")]), _c('span', {
    staticClass: "orange1"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "blued"
  }, [_vm._v("D")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "greenp"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "orange1"
  }, [_vm._v("M")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12a#ch12a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS NINETEEN &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12a#ch12b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("TWENTY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "blues"
  }, [_vm._v("K")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "bluel"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("G")]), _vm._v(" "), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "blues"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "bluel"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "gray"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("E")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13a#ch13a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("LESSONS TWENTY-ONE &")])]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13a#ch13b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("TWENTY-TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app01#app01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("GALLERY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app02#app02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("ALSO BY NATALIE GOLDBERG")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/app03#app03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("A NOTE ABOUT THIS EDITION")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0